import objectPath from "object-path";

// Normalize a string, by lowercasing and removing non-letters, numbers, and collapsing spaces
const normalizeString = (string) =>
  string
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s+/, " ");

// Look up the value at +path+ in +data+
//
// This is pretty much a pass-through to object-path.get, except for the following cases:
//
// Custom fields:
//
// path "event.location.custom_field.*" will match on place custom fields
// path "event.custom_field.*" will match on event custom fields
//
// Attendee questions:
//
// path "attendee.question.*" will match on attendee question responses
//
// For all of the above, the match is case insensitive, and normalized to remove punctuation, and will match any of id, question, label, key
//
// First/Last name
//
// path "attendee.first_name", "attendee.last_name" will return the first or remaining words of "attendee.name"
// path "purchaser.first_name", "purchaser.last_name" will return the first or remaining words of "purchaser.name"
//
// All other paths are passed through as is
export const lookupValue = function (data, path, defaultValue = null) {
  let custom_fields;
  let field_name;
  let matches;
  switch (path) {
    case "attendee.first_name":
    case "attendee.last_name":
      var name = objectPath.get(data, "attendee.name", defaultValue);

      if (path === "attendee.first_name") {
        return name.substring(0, name.indexOf(" ")).trim();
      }
      return name.substring(name.indexOf(" ")).trim();

    case "purchaser.first_name":
    case "purchaser.last_name":
      name = objectPath.get(data, "purchaser.name", defaultValue);

      if (path === "purchaser.first_name") {
        return name.substring(0, name.indexOf(" ")).trim();
      }
      return name.substring(name.indexOf(" ")).trim();
  }

  if (
    (matches = path.match(
      /^(event(?:\.location)?\.custom_field|attendee\.question)\./
    ))
  ) {
    field_name = path.substring(matches[0].length);
    custom_fields = (() => {
      switch (matches[1]) {
        case "event.location.custom_field":
          return objectPath.get(data, "event.location.custom_fields", defaultValue);
        case "event.custom_field":
          return objectPath.get(data, "event.custom_fields", defaultValue);
        case "attendee.question":
          return objectPath.get(data, "attendee.questions", defaultValue);
        default:
          return null;
      }
    })();
  }

  if (field_name && custom_fields) {
    const normalized_field_name = normalizeString(field_name);

    for (const item of Array.from(custom_fields)) {
      if (item.question && normalizeString(item.question) === normalized_field_name) {
        return item.response;
      }

      if (item.label && normalizeString(item.label) === normalized_field_name) {
        return item.value;
      }

      if (item.key && normalizeString(item.key) === normalized_field_name) {
        return item.value;
      }
    }

    return null;
  }

  return objectPath.get(data, path, defaultValue);
};
